export default "__VITE_ASSET__pSjNEHMo__"